module.exports = __webpack_public_path__ + "static/media/interactive.4f8cae57.svg";